import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { ScreenTitleComponent } from './screen-title/screen-title.component';
import { ProfileComponent } from './profile/profile.component';
import { ChangePasswordComponent } from './profile/change-password/change-password.component';
import { MaterialsModule } from '../materials/materials.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PasswordStrengthMeterComponent } from '@wise-community/angular-password-strength-meter';
import { provideZxvbnServiceForPSM } from '@wise-community/angular-password-strength-meter/zxcvbn';

@NgModule({
    declarations: [ScreenTitleComponent, ProfileComponent, ChangePasswordComponent, DashboardComponent],
    imports: [
        CommonModule,
        DashboardRoutingModule,
        MaterialsModule,
        FormsModule,
        ImageCropperComponent,
        ReactiveFormsModule,
        PasswordStrengthMeterComponent
    ],
    exports: [ScreenTitleComponent],
    providers: [provideZxvbnServiceForPSM()]
})
export class DashboardModule { }
